import React from 'react';
import Tile from './Tile';

export default function Board({ grid }: {grid : any}) {


    return (
        <table>
            <tbody>
                {
                    grid.rows.map((r:any) => (
                        <tr>
                            {r.tiles.map((t:any) => (
                                <Tile
                                    tileType={t.tileType}
                                    isLocked={t.isLocked}
                                    row={t.row}
                                    column={t.column}
                                    onClick={t.onClick} />
                            ))}
                        </tr>
                    ))
                }
            </tbody>
        </table>
    )
}